import { useQuery } from "@tanstack/react-query";
import { getDetectByDay } from "../api/detect";
import { DateFilter } from "../types/types";

interface PropsParams extends DateFilter {
  resetFetch: () => void;
  fetch: boolean;
  area: string;
  device_pid?: string;
  groupId?: string;
  mobility_code?: number;
}
const useGetDetectByDay = ({
  startDate,
  endDate,
  area,
  device_pid,
  groupId,
  mobility_code,
}: PropsParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "detect",
      `detectByDay`,
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `area-${area}`,
      `groupId-${groupId}`,
      `mobility_code-${mobility_code}`,
    ],
    queryFn: () =>
      getDetectByDay({
        startDate,
        endDate,
        area,
        device_pid,
        groupId,
        mobility_code,
      }),
    enabled: true,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    select: (data) => {
      if (data.length < 7) {
        // console.log("데이터가 7개 미만임!!");
        return undefined;
      } else {
        return data;
      }
    },
  });

  return { data, isLoading, isSuccess };
};

export default useGetDetectByDay;
